/**
 * @file src/main.tsx
 * @exports —
 * @summary Vite SPA entry point: creates the TanStack Router, wires Sentry, and mounts the app.
 */

import "./styles/fonts.css";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
// Must follow Mantine's own sheets: it narrows Mantine's 2px focus ring to cerebellum's 1px by
// source order, the doubled selectors having deliberately tied on specificity. Cortex imports the
// same file in the same position.
import "@cerebruminc/cerebellum/src/mantine/mantineGlobalStyles.css";
import "./styles/globals.css";
import { RouterProvider } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";

import { configureIosViewport } from "src/helpers/browser/configureIosViewport";
import { setAppRouter } from "src/lib/app-router";
import { initSentry } from "src/lib/sentry";
import { createAppRouter } from "src/router";

configureIosViewport({ documentObject: document, navigatorObject: navigator });

const router = createAppRouter();
setAppRouter(router);
initSentry(router);

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Root element #root not found");
}

ReactDOM.createRoot(rootElement).render(<RouterProvider router={router} />);
